exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".view-response-header {\n  display: inline-block;\n  margin-left: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/touchpoints/view-touchpoint-response.scss
// module id = 1427
// module chunks = 0